/* @flow */
import * as React from 'react';
import RequireUser from 'lib/RequireUser';
import RequireDesktop from 'lib/RequireDesktop';
import { Route, IndexRoute } from 'react-router';
import chainOnEnter from 'components/lib/chainOnEnter';
import OauthConfigPage from './components/OauthConfigPage.jsx';
import IntegrationPageIndex from './components/IntegrationPageIndex.jsx';
import IntegrationSettingsPage from './components/IntegrationSettingsPage.jsx';
import IntegrationSettingsIndex from './components/IntegrationSettingsIndex.jsx';
import ContentSourceProviderPage from './components/ContentSourceProviderPage.jsx';
import IntegrationSettingsNotFound from './components/IntegrationSettingsNotFound.jsx';
import OrganizationDeveloperConsoleAuthorizer from './components/OrganizationDeveloperConsoleAuthorizer.jsx';

const onEnter = chainOnEnter([RequireDesktop, RequireUser]);

function IntegrationPage(props) {
  return (
    <OrganizationDeveloperConsoleAuthorizer uuid={props.params.uuid}>
      {({ authorized }) => {
        if (!authorized) {
          return <IntegrationSettingsNotFound />;
        }

        return (
          <IntegrationSettingsPage uuid={props.params.uuid}>
            {props.children}
          </IntegrationSettingsPage>
        );
      }}
    </OrganizationDeveloperConsoleAuthorizer>
  );
}

export default (
  <Route path="/integrations(/)" onEnter={onEnter}>
    <IndexRoute component={IntegrationSettingsIndex} />
    <Route path=":uuid" component={IntegrationPage}>
      <IndexRoute component={IntegrationPageIndex} />
      <Route path="oauth" component={OauthConfigPage} />
      <Route path="content" component={ContentSourceProviderPage} />
    </Route>
  </Route>
);
